<template>
  <div v-if="host && shouldRender" class="ad-search-item-approval-results">
    <AdApprovalResultField
      v-for="result in results"
      :key="`${resultKeyPrefix}_${result.approvalRequestResultId}`"
      :from-admin="host.fromAdmin"
      :draft="host.getApprovalContentResultDraft(result)"
      :saved-reason="result.rejectReason"
      :result-code="result.resultCode"
      :can-save="host.canSaveApprovalContentResult(result)"
      :saving="host.isSavingApprovalContentResult(result)"
      :force-show="host.fromAdmin && host.showAdminAdRejectPanels"
      :show-reject-reason="shouldShowRejectReason"
      :templates="host.overallRejectTemplates || []"
      :actor="host.approvalRejectBy || 'AI'"
      :error="host.getFieldRejectErrorMessage?.(result) || ''"
      :result-key="String(result.approvalRequestResultId || '')"
      @update:draft="host.setApprovalContentResultDraft(result, $event)"
      @update:resultCode="host.setApprovalContentResultCode(result, $event)"
      @clear-error="host.clearFieldRejectError?.(result)"
      @save="host.saveApprovalContentResult(result)"
    />
  </div>
</template>

<script>
import AdApprovalResultField from './AdApprovalResultField.vue';
import { isVisibleApprovalRejectRow } from '@/constants/approvalRejectUi';

export default {
  name: 'AdSearchItemApprovalResults',
  components: { AdApprovalResultField },
  inject: {
    adGroupHost: { default: null },
  },
  props: {
    ad: { type: Object, default: null },
    searchItem: { type: Object, default: null },
    resultKeyPrefix: { type: String, default: 'approval_result' },
    /**
     * 成对提交时 ApprovalHeader 只挂在 PC；Mobile 自身 statusCode 常为空。
     * 由父级传入组级/PC 状态，避免手机版内容驳回原因被隐藏。
     */
    statusCode: { type: String, default: null },
  },
  computed: {
    host() {
      return this.adGroupHost;
    },
    results() {
      if (!this.host) return [];
      if (this.searchItem) {
        return this.host.getApprovalContentResultsForSearchItem(this.searchItem);
      }
      if (this.ad) {
        return this.host.getApprovalContentResults(this.ad);
      }
      return [];
    },
    /** 广告：不走 SHOW_EDIT_SUPPLIER_REJECT_REASON，默认按开启（看 showAdRejectPanels） */
    shouldShowRejectReason() {
      if (this.host?.fromAdmin) return !!this.host.showAdminAdRejectPanels;
      return !!this.host?.showAdRejectPanels;
    },
    shouldRender() {
      if (!this.results.length) return false;
      if (this.host?.fromAdmin) return !!this.host.showAdminAdRejectPanels;
      if (!this.shouldShowRejectReason) return false;
      return this.results.some((row) => isVisibleApprovalRejectRow(row, this.host));
    },
  },
};
</script>
